import { ProductDetailThemeSizeConfig } from './types';

const small: ProductDetailThemeSizeConfig = {
  productDetail: {},
};

export default small;
